import { GlobalStyle } from '@utils/styles';
import { useViewport } from '@utils/responsive';
import * as Styles from './styles';

// Components
import Header from './header';
import WhyAcko from './whyAcko';
import Partners from './partners';
import Testimonials from './testimonials';
import ClaimExperience from './claimExperience';
import Products from './products';
import Footer from './footer';

const PartnershipsLandingMain = () => {
    const { isMobile } = useViewport();

    return (
        <div>
            <GlobalStyle />
            <Styles.LandingPageWrapper>
                <Header isMobile={isMobile} />
                <WhyAcko isMobile={isMobile} />
                <Partners isMobile={isMobile} />
                <Testimonials />
                <ClaimExperience isMobile={isMobile} />
                <Products />
                <Footer />
            </Styles.LandingPageWrapper>
        </div>
    );
};

export default PartnershipsLandingMain;
